import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "percentageField",
    "amountField",
    "percentageRadio",
    "fixedAmountRadio",
  ];

  connect() {
    this.toggleFields();
  }

  toggleFields() {
    if (this.percentageRadioTarget.checked) {
      this.percentageFieldTarget.classList.remove("hidden");
      this.amountFieldTarget.classList.add("hidden");
    } else if (this.fixedAmountRadioTarget.checked) {
      this.percentageFieldTarget.classList.add("hidden");
      this.amountFieldTarget.classList.remove("hidden");
    }
  }
}
